import { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export function useRedirectTo(portal = {}) {
  const [redirectUrl, setRedirectUrl] = useState(null)
  const history = useHistory()
  const location = useLocation()

  // Parse redirect_to from URL
  const parsedRedirectUrl = useMemo(() => {
    const query = new URLSearchParams(location.search)
    return query.get('redirect_to')
  }, [location.search])

  // Initialize redirect URL from URL params
  useEffect(() => {
    if (parsedRedirectUrl && !redirectUrl) setRedirectUrl(parsedRedirectUrl)
  }, [parsedRedirectUrl, redirectUrl])

  // Generate login URL with redirect parameter
  const generateLoginUrl = useCallback(
    (targetPath = window.location.pathname) => {
      const loginPath = `/${portal.custom_login_url || 'log-in'}`
      return `${loginPath}?redirect_to=${encodeURIComponent(targetPath)}`
    },
    [portal.custom_login_url]
  )

  // Execute redirect with cleanup
  const executeRedirect = useCallback(
    (fallbackPath = '/') => {
      if (redirectUrl) {
        history.push(redirectUrl)
        setRedirectUrl(null) // Cleanup
      } else {
        history.push(fallbackPath)
      }
    },
    [history, redirectUrl]
  )

  // Clear redirect (for manual cleanup)
  const clearRedirect = useCallback(() => {
    setRedirectUrl(null)
  }, [])

  return {
    redirectUrl,
    generateLoginUrl,
    executeRedirect,
    clearRedirect
  }
}
